import { Middleware } from '@nuxt/types'

const superAdmin: Middleware = async ({ $accessor, app, error }) => {
  if (!$accessor.app.config) {
    await $accessor.app.loadConfig()
  }
  if ($accessor.app.config?.RoleName !== 'super_admin') {
    error({ statusCode: 403, message: app.i18n.t('country_admin.forbidden').toString() })
  }
}

export default superAdmin
